import _ from "lodash";
import React, { useState } from "react";
import LinkWithTooltip from "UIComponents/LinkWithTooltip";
import UIButton from "UIComponents/UIButton";
import classes from "./TagCell.scss";
import { useI18n } from "Hooks";
import getCurriculumIdsFilterForTags from "Utils/getCurriculumIdsFilterForTags";
import { AddItemsModal } from "UIComponents/GenericTableEditor/commonComponents";
import { createMultiLevelTags } from "NodeEditor/Modules/NodeEditorModule";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import classNames from "classnames";
import { getSelectedCurriculumId } from "modules/CommonSelectors";
import {
  plusButtonStyle,
  addTagButtonStyle,
  addTagLabelStyle,
} from "./TagCellStyles";

const TagCell = props => {
  const {
    tags,
    tagOptions,
    mode,
    onAddTags,
    createNewTags,
    curriculumProgramId,
  } = props;
  const [isAddTagsModalOpen, setIsAddTagsModalOpen] = useState(false);

  const { t } = useI18n(["common", "scopeAndSequence"]);

  const tagIds = _.map(tags, "id");

  const [selectedTags, setSelectedTags] = useState([]);

  const tagOptionsObjectMap = _.keyBy(tagOptions, "id");

  const tagLabelAndIcons = _.map(tagIds, tagId => {
    const label = _.get(tagOptionsObjectMap[tagId], "label", "");
    const iconURL = _.get(tagOptionsObjectMap[tagId], "icon.url", "");
    return { id: tagId, label, iconURL };
  });

  const MAX_TAGS_TO_DISPLAY = 2;

  const tooltipElement = (
    <div>
      {_.map(
        _.slice(tagLabelAndIcons, MAX_TAGS_TO_DISPLAY, Infinity),
        ({ label, id }) => {
          return (
            <React.Fragment key={id}>
              {label}
              <br />
            </React.Fragment>
          );
        }
      )}
    </div>
  );

  const toggleAddTagsModal = () => {
    setIsAddTagsModalOpen(prevState => !prevState);
    setSelectedTags([]);
  };

  const onCreateNewTag = async value => {
    const newTags = await createNewTags([
      {
        label: value,
        ...getCurriculumIdsFilterForTags({
          curriculumProgramId,
          isMutation: true,
        }),
      },
    ]);

    if (newTags) {
      setSelectedTags(prevTags => [...prevTags, ...newTags]);
    }
  };

  const handleAddTags = () => {
    onAddTags({
      itemsList: selectedTags,
    });

    toggleAddTagsModal();
  };

  const TagLabel = ({ label, index }) => {
    const tagContainerClasses = classNames(classes.tag, classes.tagLabel);
    return (
      <LinkWithTooltip
        trigger={["hover", "focus"]}
        tooltip={label}
        linkStyles={plusButtonStyle}
        placement={"right"}
      >
        <div key={index} className={tagContainerClasses} tabIndex="0">
          <span className={classes.label}>{label}</span>
        </div>
      </LinkWithTooltip>
    );
  };

  return (
    <div className={classes.container}>
      <div className={classes.tagsContainer}>
        {_.isEmpty(tagLabelAndIcons) ? <div>{"--"}</div> : null}
        {_.map(
          _.slice(tagLabelAndIcons, 0, MAX_TAGS_TO_DISPLAY),
          ({ label, iconURL, id }) => (
            <TagLabel label={label} iconURL={iconURL} key={id} />
          )
        )}
        {_.size(tagLabelAndIcons) > MAX_TAGS_TO_DISPLAY ? (
          <LinkWithTooltip
            tooltip={tooltipElement}
            trigger={["click", "focus"]}
            placement={"right"}
            linkStyles={plusButtonStyle}
          >
            <div className={classes.tag} tabIndex="0">
              <span className={classes.label}>
                {`+${_.size(tagLabelAndIcons) - MAX_TAGS_TO_DISPLAY}`}
              </span>
            </div>
          </LinkWithTooltip>
        ) : null}
      </div>
      {mode === "edit" ? (
        <UIButton
          className={classes.addTagBtn}
          size="sm"
          type="hollow"
          containerStyle={addTagButtonStyle}
          labelStyle={addTagLabelStyle}
          color="blue"
          onClick={toggleAddTagsModal}
        >
          {t("common:add")}
        </UIButton>
      ) : null}
      {isAddTagsModalOpen ? (
        <AddItemsModal
          items={tagOptions}
          onClickButton1={toggleAddTagsModal}
          onClickButton2={handleAddTags}
          buttonText1={t("common:cancel")}
          buttonText2={t("common:add")}
          modalTitle={t("common:add_with_label", { label: t("common:tags") })}
          searchPlaceholderText={t("scopeAndSequence:no_item_added", {
            type: t("common:tags"),
          })}
          noItemsAddedText={t("scopeAndSequence:no_item_added", {
            type: t("common:tags"),
          })}
          noItemsText={t("scopeAndSequence:no_item_created", {
            type: t("common:tags"),
          })}
          noItemsSubText={t("scopeAndSequence:go_ahead_tags_desc", {
            msg: t("scopeAndSequence:create_first_tag"),
          })}
          isCreateItems={true}
          onCreateItemClick={onCreateNewTag}
          itemName={t("common:tag")}
          selectedItemsList={selectedTags}
          setSelectedItemsList={setSelectedTags}
        />
      ) : null}
    </div>
  );
};

const mapStateToProps = state => {
  const curriculumProgramId = getSelectedCurriculumId(state);
  return {
    curriculumProgramId,
  };
};

const mapActionCreators = {
  createMultiLevelTags,
};
export default compose(connect(mapStateToProps, mapActionCreators))(TagCell);
